const exportErrorRegex = /\[\[\s+export error:\s+(.*?)\]\]/;

export const getExportErrorText = (string) => string.match(exportErrorRegex);

export const removeExportErrorText = (string) => string.replace(exportErrorRegex, "");



// WEBPACK FOOTER //
// ./src/js/utils/regex.js